import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, switchMap, tap } from 'rxjs/operators';
import { ApiService } from '../api/api.service';
import { Assessment } from '../models/models.lib';
import { LoggerService } from '../shared/logger.service';
const { apiUrl } = environment;

export abstract class CasiAssessmentService extends BehaviorSubject<Assessment | null> {
  public loading: boolean = false;
  public apiService = inject(ApiService);
  private loggerService = inject(LoggerService);

  constructor(
    private http: HttpClient,
  ) {
    super(null);
  }

  public query(id: number, fieldName: string, assessment_id?: any): void {
    this.fetch(id, fieldName, assessment_id).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(id: number, fieldName: string, assessment_id?: any): Observable<Assessment> {
    this.loading = true;
    // return this.apiService.getCsrf()
    //   .pipe(
    //     switchMap((token: any) => {
    //       this.loggerService.debug(`fetch:token: `, token);
    //       return this.http
    //         .post<Assessment>(
    //           encodeURI(`${apiUrl}/assessment`),
    //           { assessment_id, id, fieldName },
    //           {
    //             withCredentials: true
    //           }
    //         )
    //     })
    //   )
    return this.apiService.insertCsrf('/assessment', 'POST', { assessment_id, id, fieldName })
      .pipe(
        map(response => Assessment.create(response)),
        tap(() => {
          this.loading = false;
        })
      );
    // .subscribe({
    //       next: token => {
    //         return this.http
    //           .post<Assessment>(
    //             encodeURI(`${apiUrl}/assessment`),
    //             { assessment_id, id, fieldName },
    //             {
    //               withCredentials: true
    //             }
    //           )

    //           .pipe(
    //             map(response => Assessment.create(response)),
    //             tap(() => (this.loading = false))
    //           );
    //       },
    //       error: err => {
    //         console.error(`error: `, err);
    //         return throwError(() => err);
    //       }
    //     })

    //   return this.http.post<Assessment>(
    //     encodeURI(`${apiUrl}/assessment`),
    //     { assessment_id, id, fieldName }
    //   )
    //     .pipe(
    //       map(response => Assessment.create(response)),
    //       tap(() => (this.loading = false))
    //     );
  }

}
@Injectable({
  providedIn: 'root'
})
export class AssessmentService extends CasiAssessmentService {
  constructor(
    http: HttpClient,
    // private apiService: ApiService
  ) {
    super(http)
  }

  get(id: number, fieldName: string, assessment_id?: number) {
    return this.apiService.postHttpCall(`/assessment`, { assessment_id, id, fieldName }, 'get');
  }

  save(dataItem: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise(`assessment/save`, dataItem, 'save');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`assessment/${id}`, dataItem, 'update');
  }

  reopen(id: number): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`assessment/reopen/${id}`, {}, 'reopen');
  }

  reset(id: number, fieldName: string): Promise<any> {
    return this.apiService.postHttpCallAsPromise(`assessment/reset`, {id, fieldName}, 'reset');
  }
}

